import eventimage1 from "../images/event1.webp";
import eventimage2 from "../images/event_image2.webp";
import eventimage3 from "../images/event_image3.webp";
import eventimage4 from "../images/event_image_4.webp";
import eventimage5 from "../images/event_image5.webp";

const Events = [
  {
    id: "Edukasi Ceria Spesial Hari Anak Nasional",
    title: "Edukasi Ceria Spesial Hari Anak Nasional",
    date: "28 JUL 2024",
    image: eventimage5,
    description:
      "Edukasi Ceria memperingati Hari Anak Nasional dengan beragam kegiatan permainan tradisional, bertujuan untuk mengenalkan kembali permainan-permainan tradisional kepada anak-anak.",
    modalContent:
      "Edukasi Ceria memperingati Hari Anak Nasional dengan mengadakan rangkaian kegiatan yang berfokus pada permainan tradisional. Acara berlangsung pada tanggal 28 Juli 2024 di Tugu Batu Putih. Acara ini dirancang untuk mengenalkan kembali kepada anak-anak berbagai permainan tradisional yang telah lama dikenal, namun mulai terlupakan. Melalui kegiatan yang interaktif dan menyenangkan ini, anak-anak diajak untuk belajar dan bermain bersama.",
    listActivity: ["Engklek", "Tarek Siteuk", "Lompat Karet", "Tam Tam Buku"],
    listBenefit: [
      "Menurunkan emosi negatif",
      "Melatih fokus",
      "Meningkatkan kemampuan kognitif (Menganalisa)",
      "Melatih kemampuan motorik kasar-halus",
      "Mengembangkan sosial",
      "Meningkatkan kemampuan bahasa",
    ],
  },
  {
    id: "Serial Crafting: Membuat Boneka Horta",
    title: "Serial Crafting: Membuat Boneka Horta",
    date: "19 MEI 2024",
    image: eventimage4,
    description:
      "Serial Crafting: Membuat Boneka Horta adalah kegiatan kreatif yang dirancang untuk mengajarkan anak-anak seni kerajinan tangan.",
    modalContent:
      "Serial Crafting: Membuat Boneka Horta adalah kegiatan kreatif yang dirancang untuk mengajarkan anak-anak seni kerajinan tangan. Melalui aktivitas ini, anak-anak akan belajar membuat Boneka Horta dengan cara yang menyenangkan dan edukatif, sambil mengembangkan keterampilan motorik dan kreativitas mereka. Kegiatan ini berlangsung pada tanggal 19 Mei 2024 di praktik psikolog Edukasi Ceria.",
    listActivity: ["Mengenal dan Membuat Boneka Horta"],
    listBenefit: [
      "Meningkatkan kecerdasan naturalis",
      "Motorik halus",
      "Kreativitas",
      "Rasa tanggung jawab",
      "Konsistensi",
      "Disiplin",
    ],
  },
  {
    id: "Educational Play 'Siapa Tsunami?'",
    title: 'Educational Play "Siapa Tsunami?"',
    date: "24 DES 2023",
    image: eventimage3,
    description:
      "Dalam rangka memperingati Tsunami Aceh 2004, Edukasi Ceria mengadakan kegiatan untuk anak-anak yang mencakup pengenalan tentang tsunami, eksperimen sains, dan kesiapsiagaan melalui permainan edukatif.",
    modalContent:
      "Dalam rangka memperingati Tsunami Aceh 2004, Edukasi Ceria mengadakan kegiatan khusus untuk anak-anak yang bertujuan untuk meningkatkan pemahaman mereka tentang tsunami. Acara ini mencakup eksperimen sains yang menarik serta permainan edukatif yang dirancang untuk mengajarkan kesiapsiagaan menghadapi bencana. Dengan pendekatan yang interaktif dan menyenangkan, anak-anak diajak untuk mengenal fenomena tsunami secara lebih mendalam dan mempelajari langkah-langkah penting dalam kesiapsiagaan bencana. Kegiatan ini berlangsung pada tanggal 14 Desember 2023 di praktik psikolog Edukasi Ceria, memberikan pengalaman yang edukatif dan bermanfaat bagi para peserta.",
    listActivity: [
      "Storytelling Tsunami",
      "Eksperimen Sains: Tsunami",
      "Kesiapsiagaan Tsunami: Melatih Regulasi Emosi dan Membuat Pelampung Darurat",
    ],
    listBenefit: [
      "Meningkatkan pemahaman tentang tsunami",
      "Meningkatkan kesiapsiagaan menghadapi bencana",
      "Melatih regulasi emosi dan keterampilan sosial",
      "Meningkatkan kesadaran akan pentingnya keselamatan",
      "Meningkatkan pengetahuan tentang sains dan alam",
    ],
  },
  {
    id: "Edukasi Ceria Spesial Parent-Kids' Day",
    title: "Edukasi Ceria Spesial Parent-Kids' Day",
    date: "15 OKT 2023",
    image: eventimage2,
    description:
      "Edukasi Ceria memperingati Hari Kesehatan Mental Sedunia dengan acara Parent-Kid's Day, menghadirkan kegiatan bersama orang tua dan anak untuk meningkatkan kesadaran kesehatan mental dalam keluarga.",
    modalContent:
      "Edukasi Ceria memperingati Hari Kesehatan Mental Sedunia dengan mengadakan Parent-Kid's Day. Acara ini menghadirkan berbagai kegiatan interaktif yang melibatkan orang tua dan anak untuk meningkatkan kesadaran akan pentingnya kesehatan mental dalam keluarga. Dengan berbagai aktivitas menarik yang dirancang khusus untuk mempererat hubungan keluarga dan mendukung kesejahteraan mental, acara ini berhasil memberikan manfaat yang berkelanjutan. Kegiatan ini berlangsung pada tanggal 15 Oktober 2023 di Estrella Cafe, Batu Putih, dan menjadi momen berharga yang penuh dengan pembelajaran dan kebersamaan.",
    listActivity: [
      "Senam",
      "Brain Gym",
      "Kids' Play Therapy",
      "A Day with My Life (Kegiatan Journaling Anak dan Orang Tua)",
      "Bilateral & Balancing: Permainan Kerja sama, Konsentrasi, dan Keseimbangan antara Orang Tua dan Anak",
      "Kita Butuh Bicara: Parents-Kids' Talk",
    ],
    listBenefit: [
      "Meningkatkan kelekatan, kemampuan memori dan kemampuan berbicara",
      "Melatih kemampuan visual, kemampuan motorik halus dan kemampuan mengelola emosi",
      "Mengenal diri anak dan meningkatkan kesejahteraan psikologis",
      "Melatih keseimbangan, konsentrasi dan kemampuan berkomunikasi",
      "Menumbuhkan konsep diri, kreativitas, daya saing dan daya juang",
      "Mengembangkan kognitif, menumbuhkan keberanian dan kepercayaan diri anak",
    ],
  },
  {
    id: "Edukasi Ceria Spesial Hari Anak Nasional",
    title: "Edukasi Ceria Spesial Hari Anak Nasional",
    date: "30 JUL 2023",
    image: eventimage1,
    description:
      "Edukasi Ceria memperingati Hari Anak Nasional dengan kegiatan seperti senam, brain gym, dan melukis totebag melalui art terapi, yang membantu meningkatkan kreativitas, motorik halus, sosial, konsentrasi, dan manfaat lainnya.",
    modalContent:
      "Edukasi Ceria memperingati Hari Anak Nasional dengan mengadakan serangkaian kegiatan pada tanggal 30 Juli 2023 di praktik psikolog Edukasi Ceria. ",
    listActivity: [
      "Senam",
      "Brain Gym",
      "Melukis Totebag menggunakan Art Terapi",
      "Melukis Totebag dari Angka",
      "Meningkatkan Kreativitas",
    ],
    listBenefit: [
      "Meningkatkan Kreativitas",
      "Motorik Halus",
      "Kemampuan Sosial",
      "Konsentrasi dan Fokus",
      "Self Efficacy dan Self Confidence",
      "Mengeksplorasi Emosi",
      "Mengurangi Kecanduan",
      "Menjaga Kesejahteraan Psikologis",
      "Meningkatkan Self Esteem",
      "Koordinasi Visual Motor",
      "Daya Ingat",
      "Kekuatan Otot dan Tulang",
      "Tote Bag dan Goodie Bag",
    ],
  },
];

export default Events;
